import React, { useState } from 'react'
import StyledText from '../../../components/StyledComponents/StyledText';
import FormikSelect from '../../../components/Formik/FormikSelect';
import { useTheme } from '../../../middleware/ThemeContext';
import StyledCheckBox from '../../../components/StyledComponents/CheckBox/StyledCheckBox';
import ToggleSwitch from '../../../components/StyledComponents/StyledToggle';
import { MembershipTypeFormValues, EligibilityRuleType } from '../../../types/types';
import FormikInputField from '../../../components/Formik/FormikInputField';
import styled from 'styled-components';
import { font, FontType, Theme } from '../../../utils/themes';
import AlertNotice from '../dashboard/Components/AlertNotice';
import AddPriceTier from './AddPriceTier';
import AddIcon from '../../../assets/icons/AddIcon';
import ProrationListing from './ProrationListing';
import DeleteIcon from '../../../assets/icons/DeleteIcon';
import MultiYearPricingAdd from './MultiYearPricingAdd';
import AddFeeSettings from './AddFeeSettings';

interface PriceAndArchitectureProps {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
    values: MembershipTypeFormValues;
}

const PriceAndArchitecture: React.FC<PriceAndArchitectureProps> = ({ setFieldValue, values }) => {
  const {theme} = useTheme();
  const [showAddTier, setShowAddTier] = useState(false);
  const [showAddFee, setShowAddFee] = useState(false);

  // const eligibilityOptions: { label: string; value: EligibilityRuleType }[] = [
  //   { label: 'Anyone can purchase', value: 'anyone-can-purchase' },
  //   { label: 'Individuals Only', value: 'individuals-only' },
  //   { label: 'Organizations Only', value: 'organizations-only' },
  //   { label: 'Only user with specific attributes', value: 'only-users-with-specific-attributes' },
  //   { label: 'Only user in certain chapters', value: 'only-users-in-certain-chapters' },
  // ];

  // const handleCheckboxChange = (ruleValue: EligibilityRuleType, isChecked: boolean) => {
  //   const currentRules = values.eligibilityRules || [];
  //   let updatedRules: EligibilityRuleType[];

  //   if (isChecked) {
  //     updatedRules = [...currentRules, ruleValue];
  //   } else {
  //     updatedRules = currentRules.filter((rule) => rule !== ruleValue);
  //   }

  //   setFieldValue('eligibilityRules', updatedRules);
  // };

  

  return (
    <>
      {/* <StyledText className='mb-4'>
          Purchase Eligibility
      </StyledText> */}

      <div className='mb-3'>
          {/* <div className='d-flex align-items-center justify-content-between mb-4'>
            <StyledText
                // className="mb-4"
                textColor={theme.CorporateTheme?.colors?.headerColor}
            >
                Enable Eligibility Rules
            </StyledText>
            <ToggleSwitch
                checked={values.eligibilityRulesEnabled}
                activeColor={theme.CorporateTheme.colors.primary}
                inactiveColor={theme.CorporateTheme.colors.textSecondary}
                knobColor={theme.CorporateTheme.colors.background}
                onChange={() => setFieldValue("eligibilityRulesEnabled", !values.eligibilityRulesEnabled)}
                noPaddingNeeded
                showTitle={false}
                // disabled={isView}
            />
          </div> */}
          {/* {values.eligibilityRulesEnabled && (
            <div className='mb-3 d-grid gap-2 row-gap-4' style={{ gridTemplateColumns: '1fr 1fr' }}>
                {eligibilityOptions.map((option) => (
                  <div key={option.value}>
                    <StyledCheckBox 
                        label={option.label}
                        borderColor={theme.CorporateTheme?.colors?.textSecondary}
                        bgColor={theme.CorporateTheme?.colors?.primary}
                        checkColor="white"
                        color={theme.CorporateTheme?.colors?.headerColor}
                        size={15}
                        value={values.eligibilityRules?.includes(option.value) || false}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          handleCheckboxChange(option.value, e.target.checked);
                        }}
                    />
                  </div>
                ))}
            </div>
          )}

          <hr style={{ color: theme.CorporateTheme.colors.border, opacity: 1 }} /> */}

          <StyledText className='mb-4'>
              Base Pricing
          </StyledText>

          <BGFields theme={theme}>
            <StyledText
                className="mb-2"
                textColor={theme.CorporateTheme?.colors?.headerColor}
            >
                Base Price
            </StyledText>
            <FormikInputField
                className='mb-3'
                name="basePrice"
                type='number'
                min={0}
                // maxChar={120}
                // as='textarea'
                placeholder="Enter base price here"
                onChange={(e) => {
                    setFieldValue("basePrice", Number(e.target.value));
                    // dispatch(setQueryName({ name: e.target.value }));
                }}
                suffix='$'
            />
          </BGFields>

          <hr style={{ color: theme.CorporateTheme.colors.border, opacity: 1 }} />

          <StyledText className='mt-4 mb-4'>
              Special Pricing
          </StyledText>

          <BGFields theme={theme} className='mb-3'>
            {values.specialPriceTier.length > 0 ?
            <table style={{ width: '100%' }}> 
              <thead className='border-bottom'>
                <tr>
                  <TableHeader theme={theme}>Tire Name</TableHeader>
                  <TableHeader theme={theme} style={{ textAlign: 'center' }}>Eligibility Criteria</TableHeader>
                  <TableHeader theme={theme}>Price</TableHeader>
                  <TableHeader theme={theme} style={{ textAlign: 'center', width: '50px' }}>Action</TableHeader>
                </tr>
              </thead>
              <tbody>
                {values.specialPriceTier.map((tier, index) => (
                  <tr key={index}>
                    <td 
                      style={{ 
                        textAlign: 'left', 
                        padding: '14px 0px', 
                        color: theme.CorporateTheme.colors.headerColor, 
                        fontSize: '14px', 
                        fontWeight: '600' 
                      }}
                    >
                      {tier.tierName}
                    </td>
                    <td 
                      style={{ 
                        textAlign: 'center', 
                        padding: '14px 0px' 
                      }}
                    >
                      <EligibilityCriteriaTag theme={theme}>
                        {`${tier.eligibilityType === 'contact-role' ? 'Contact Role' : 'Organization Role'} ${tier.operator === 'is' ? 'Is' : 'Is Not'} ${tier.eligibilityRole}`}
                      </EligibilityCriteriaTag>
                    </td>
                    <td 
                    style={{ 
                      textAlign: 'left', 
                      padding: '14px 0px',
                      fontSize: '13px',
                      fontWeight: '600',
                      color: theme.CorporateTheme.colors.textSecondary
                      }}
                    >
                      $<span style={{ fontFamily: font.lato }} >{tier.tierPrice}</span>
                    </td>
                    <td 
                    style={{ 
                      textAlign: 'center', 
                      padding: '14px 0px'
                      }}
                    >
                      <DeleteIcon 
                        color={theme.CorporateTheme.colors.textSecondary}
                        size={20}
                        className="cursor-pointer"
                        onClick={() => {
                          const updatedTiers = values.specialPriceTier.filter((_, idx) => idx !== index);
                          setFieldValue('specialPriceTier', updatedTiers);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            : 
            <StyledText
              className='cursor-pointer'
              textColor={theme.CorporateTheme.colors.blueberry}
              onClick={() => setShowAddTier(true)}
            >
              <AddIcon color={theme.CorporateTheme.colors.blueberry} />
              Add Pricing Tier
            </StyledText>
            }
          </BGFields>
          {showAddTier &&
            <AddPriceTier
              close={() => setShowAddTier(false)}
              // create={() => {}}
              values={values}
              setFieldValue={setFieldValue}
            />
          }
          {values.specialPriceTier.length > 0 &&
            <StyledText
              className='cursor-pointer mb-4'
              textColor={theme.CorporateTheme.colors.blueberry}
              onClick={() => setShowAddTier(true)}
            >
              <AddIcon color={theme.CorporateTheme.colors.blueberry} />
              Add Pricing Tier
            </StyledText>
          }

          {values.termType === 'fixed' &&
            <BGFields theme={theme}>
              <div className='d-flex align-items-center justify-content-between mb-4'>
                <StyledText 
                  textColor={theme.CorporateTheme?.colors?.accentOrange}
                >
                    Enable Proration
                </StyledText>
                <ToggleSwitch
                    checked={values.prorationEnabled}
                    activeColor={theme.CorporateTheme.colors.primary}
                    inactiveColor={theme.CorporateTheme.colors.textSecondary}
                    knobColor={theme.CorporateTheme.colors.background}
                    onChange={() => setFieldValue("prorationEnabled", !values.prorationEnabled)}
                    noPaddingNeeded
                    showTitle={false}
                    // disabled={isView}
                />
              </div>
              {values.prorationEnabled && (
                <>
              <hr style={{ color: theme.CorporateTheme.colors.border, opacity: 1 }} />

              <StyledText
                  style={{ textTransform: 'capitalize' }}
                  className=" mb-2"
                  textColor={theme.CorporateTheme?.colors?.headerColor}
              >
                  {values.prorationMethod} Proration Method
              </StyledText>
              {/* <StyledText style={{ textTransform: 'capitalize' }}
                fontSize='14px'
                fontWeight={600}
                textColor={theme.CorporateTheme.colors.blueberry}
              >
                {values.prorationMethod}
              </StyledText> */}
              {/* <FormikSelect
                  className={`mb-2`}
                  options={[
                      { label: "Monthly", value: "monthly" },
                      { label: "Quarterly", value: "quarterly" },
                  ]}
                  name="prorationMethod"
                  placeholder="Select proration method"
                  onChange={(
                      val:
                          | string
                          | { label: string; value: number | string }
                  ) => {
                      const value =
                          typeof val === "string" ? val : val.value;
                      setFieldValue("prorationMethod", value);
                      // setSelectedRole(String(value));
                  }}
                  // disabled={id ? true : false}
              /> */}
              <AlertNotice 
                  message='The dollar amount shown for each month is the final prorated dues amount, not the discount.'
              />

              <ProrationListing 
                prorationType={values.prorationMethod}
              />

              </>
              )}
            </BGFields>
          }

          <hr style={{ color: theme.CorporateTheme.colors.border, opacity: 1 }} />

          {values.termType === 'anniversary' &&
            <>
            <StyledText className='mt-4 mb-4'>
                Multi-Year Pricing
            </StyledText>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <StyledText 
                  textColor={theme.CorporateTheme?.colors?.headerColor}
                >
                    Enable Multi-Year Pricing
                </StyledText>
                <ToggleSwitch
                    checked={values.multiYearPricing}
                    activeColor={theme.CorporateTheme.colors.primary}
                    inactiveColor={theme.CorporateTheme.colors.textSecondary}
                    knobColor={theme.CorporateTheme.colors.background}
                    onChange={() => setFieldValue("multiYearPricing", !values.multiYearPricing)}
                    noPaddingNeeded
                    showTitle={false}
                    // disabled={isView}
                />
              </div>
              {values.multiYearPricing && (
                <MultiYearPricingAdd 
                  values={values}
                  setFieldValue={setFieldValue}
                />
              )}
              <hr style={{ color: theme.CorporateTheme.colors.border, opacity: 1 }} />
              </>
          }


          <StyledText className='mt-4 mb-4'>
              Payment Timing
          </StyledText>

          <div>
            <label className='d-flex gap-2 mb-4'>
              <input 
                type='radio' 
                name='paymentTiming' 
                value='pay-now' 
                checked={values.paymentTiming === 'pay-now'} 
                onChange={(e) => setFieldValue('paymentTiming', e.target.value)} 
              />
              <div>
                <StyledText
                  className='mb-2'
                  textColor={theme.CorporateTheme.colors.mirage}
                >
                  Pay Now
                </StyledText>
                <StyledText
                  textColor={theme.CorporateTheme.colors.textSecondary}
                  fontSize='12px'
                  fontWeight={400}
                >
                  The applicant pays immediately when submitting the membership application.
                </StyledText>
              </div>
            </label>
            <label className='d-flex gap-2 mb-4'>
              <input 
              type='radio' 
              name='paymentTiming' 
              value='pay-after-approval'
              checked={values.paymentTiming === 'pay-after-approval'} 
              onChange={(e) => setFieldValue('paymentTiming', e.target.value)}
              />
              <div>
                <StyledText
                  className='mb-2'
                  textColor={theme.CorporateTheme.colors.mirage}
                >
                  Pay After Approval
                </StyledText>
                <StyledText
                  textColor={theme.CorporateTheme.colors.textSecondary}
                  fontSize='12px'
                  fontWeight={400}
                >
                  The applicant submits the application without paying. The admin reviews the application first. Once approved, the applicant is asked to pay
                </StyledText>
              </div>
            </label>
            <label className='d-flex gap-2 mb-4'>
              <input 
                type='radio' 
                name='paymentTiming' 
                value='bill-me-later'
                checked={values.paymentTiming === 'bill-me-later'} 
                onChange={(e) => setFieldValue('paymentTiming', e.target.value)}
              />
              <div>
                <StyledText
                  className='mb-2'
                  textColor={theme.CorporateTheme.colors.mirage}
                >
                  Invoice / Bill Me Later
                </StyledText>
                <StyledText
                  textColor={theme.CorporateTheme.colors.textSecondary}
                  fontSize='12px'
                  fontWeight={400}
                >
                  Instead of paying immediately, the system generates an invoice send to buyer and then buyer pays the bill.
                </StyledText>
              </div>
            </label>
          </div>

          <hr style={{ color: theme.CorporateTheme.colors.border, opacity: 1 }} />

          <div className='d-flex align-items-center justify-content-between mb-4'>
            <StyledText>
                Additional Fee Settings
            </StyledText>
            <ToggleSwitch
                checked={values.additionalFeeSettingsEnable}
                activeColor={theme.CorporateTheme.colors.primary}
                inactiveColor={theme.CorporateTheme.colors.textSecondary}
                knobColor={theme.CorporateTheme.colors.background}
                onChange={() => setFieldValue("additionalFeeSettingsEnable", !values.additionalFeeSettingsEnable)}
                noPaddingNeeded
                showTitle={false}
                // disabled={isView}
            />
          </div>

          {values.additionalFeeSettingsEnable && 
            <>
              <BGFields theme={theme} className='mb-3'>
                {values.additionalFeeSettings.length > 0 ?
                <table style={{ width: '100%' }}> 
                  <thead className='border-bottom'>
                    <tr>
                      <TableHeader theme={theme}>Fee Name</TableHeader>
                      <TableHeader theme={theme} style={{ textAlign: 'center' }}>Applies During</TableHeader>
                      <TableHeader theme={theme}>Fee Amount</TableHeader>
                    </tr>
                  </thead>
                  <tbody>
                    {values.additionalFeeSettings.map((fee, index) => (
                      <tr key={index}>
                        <td 
                          style={{ 
                            textAlign: 'left', 
                            padding: '14px 0px', 
                            color: theme.CorporateTheme.colors.headerColor, 
                            fontSize: '14px', 
                            fontWeight: '600' 
                          }}
                        >
                          {fee.feeName}
                        </td>
                        <td 
                          style={{ 
                            textAlign: 'center', 
                            padding: '14px 0px' 
                          }}
                        >
                          <EligibilityCriteriaTag theme={theme}>
                            {fee.applyFeeTo}
                          </EligibilityCriteriaTag>
                        </td>
                        <td 
                        style={{ 
                          textAlign: 'left', 
                          padding: '14px 0px',
                          fontSize: '13px',
                          fontWeight: '600',
                          color: theme.CorporateTheme.colors.textSecondary
                          }}
                        >
                          $<span style={{ fontFamily: font.lato }} >{fee.feeAmount}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                : 
                <StyledText
                  className='cursor-pointer'
                  textColor={theme.CorporateTheme.colors.blueberry}
                  onClick={() => setShowAddFee(true)}
                >
                  <AddIcon color={theme.CorporateTheme.colors.blueberry} />
                  Add Pricing Fee
                </StyledText>
                }
              </BGFields>

              {showAddFee &&
                <AddFeeSettings 
                  close={() => setShowAddFee(false)}
                  values={values}
                  setFieldValue={setFieldValue}
                />
              }
              {values.additionalFeeSettings.length > 0 &&
                <StyledText
                  className='cursor-pointer mt-3 mb-4'
                  textColor={theme.CorporateTheme.colors.blueberry}
                  onClick={() => setShowAddFee(true)}
                >
                  <AddIcon color={theme.CorporateTheme.colors.blueberry} />
                  Add Pricing Fee
                </StyledText>
              }
            </>
          }

      </div>
    </>
  )
}

export default PriceAndArchitecture

export const BGFields = styled.div<{ theme?: Theme }>`
  background-color: ${({ theme }) => theme.CorporateTheme.colors.background};
  padding: 15px;
  border-radius: 5px;
`;

const TableHeader = styled.th<{ theme?: Theme }>`
  text-align: left;
  padding: 8px 0px;
  color: ${({ theme }) => theme.CorporateTheme.colors.textSecondary};
  font-weight: 500;
  font-size: 13px;
`;

const EligibilityCriteriaTag = styled.span<{ theme: Theme }>`
  padding: 8px 15px;
  background-color: ${({theme}) => theme.CorporateTheme.colors.filterBG};
  border-radius: 37px;
  font-size: 12px;
  font-weight: 500;
  color: ${({theme}) => theme.CorporateTheme.colors.textSecondary};
`;
